// extracted by css-extract-rspack-plugin
export default {"Link":"PullRequestLink-module__Link__gmWy7"};